import { Quill } from 'react-quill-new'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const Block = Quill.import('blots/block') as any
class CustomBlock extends Block {
  static create() {
    const node = super.create() as HTMLElement
    node.classList.add('body-default')
    return node
  }
}
CustomBlock.tagName = 'P'
Quill.register('blots/block', CustomBlock, true)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const Header = Quill.import('formats/header') as any
class CustomHeader extends Header {
  static create(value: number | string) {
    const node = super.create(value) as HTMLElement
    const level = typeof value === 'string' ? parseInt(value, 10) : value
    const classMap: Record<number, string> = {
      1: 'heading-medium',
      2: 'heading-small',
      3: 'heading-xsmall',
    }
    if (classMap[level]) {
      node.classList.add(classMap[level])
    }
    return node
  }
}
Quill.register('formats/header', CustomHeader, true)
